import React from 'react'

export default function Locations(props) {
    

    return (
        <>
            <h3>Locations</h3>
        </>
    )
}
